/* Age Gate — Birdie Shots */
(function() {
  const gate = document.getElementById('age-gate');
  if (!gate) return;

  if (!localStorage.getItem('bs_age_verified')) {
    gate.style.display = 'flex';
    document.body.style.overflow = 'hidden';
    gate.setAttribute('aria-hidden', 'false');
    gate.querySelector('button, a')?.focus();
  }

  document.getElementById('age-gate-yes')?.addEventListener('click', function() {
    localStorage.setItem('bs_age_verified', '1');
    gate.style.transition = 'opacity 0.4s ease';
    gate.style.opacity = '0';
    setTimeout(() => {
      gate.style.display = 'none';
      document.body.style.overflow = '';
      gate.setAttribute('aria-hidden', 'true');
    }, 400);
  });

  document.getElementById('age-gate-no')?.addEventListener('click', function() {
    window.location.href = 'https://www.google.com';
  });
})();

/* Cookie Consent — Birdie Shots */
(function() {
  const banner = document.getElementById('cookie-consent');
  if (!banner) return;

  if (!localStorage.getItem('bs_cookies_accepted')) {
    setTimeout(() => banner.classList.add('is-visible'), 1000);
  }

  function dismiss(accepted) {
    banner.classList.remove('is-visible');
    localStorage.setItem('bs_cookies_accepted', accepted ? 'all' : 'none');
    if (!accepted) {
      // Disable analytics if declined
      window['ga-disable'] = true;
    }
  }

  document.getElementById('cookie-accept')?.addEventListener('click', () => dismiss(true));
  document.getElementById('cookie-decline')?.addEventListener('click', () => dismiss(false));
})();
